/* ClosetRehab 1nov26 — Casilla obligatoria antes de pagar. Delegación en document (fase de captura). */
(function(){
  if (window.__crCasilla) return; window.__crCasilla = true;
  var KEY = 'cr_casilla_politicas';
  function ok(){ try { return sessionStorage.getItem(KEY) === '1'; } catch(e){ return false; } }
  function set(v){ try { v ? sessionStorage.setItem(KEY,'1') : sessionStorage.removeItem(KEY); } catch(e){} }
  function boxes(){ return document.querySelectorAll('[data-cr-casilla]'); }
  function sync(){
    var v = ok();
    boxes().forEach(function(b){
      var i = b.querySelector('[data-cr-casilla-input]'); if (i) i.checked = v;
      if (v){ b.classList.remove('is-error'); var e=b.querySelector('[data-cr-casilla-error]'); if(e) e.hidden=true; }
    });
    document.querySelectorAll('button[name="checkout"],input[name="checkout"]').forEach(function(btn){
      btn.classList.toggle('cr-casilla-bloqueado', !v); btn.setAttribute('aria-disabled', v ? 'false' : 'true');
    });
  }
  function nearest(el){
    var scope = el.closest('form, [data-cr-scope], cart-drawer, .\\#cart-drawer, .\\#cart-sidebar, aside, section') || document;
    return scope.querySelector('[data-cr-casilla]') || document.querySelector('[data-cr-casilla]');
  }
  function showError(el){
    boxes().forEach(function(b){ b.classList.add('is-error'); var e=b.querySelector('[data-cr-casilla-error]'); if(e) e.hidden=false; });
    var b = nearest(el); if (b){ b.scrollIntoView({block:'center',behavior:'smooth'}); var i=b.querySelector('input'); if(i) i.focus({preventScroll:true}); }
  }
  // ¿Este elemento lleva al checkout?
  function isCheckout(t){
    if (!t || !t.closest) return null;
    var el = t.closest('[name="checkout"], a[href*="/checkout"], cart-dynamic-checkout, shopify-accelerated-checkout-cart, .shopify-cleanslate, [data-shopify="dynamic-checkout-cart"]');
    if (!el) return null;
    // Solo bloquear si en la página hay una casilla (no tocar fichas de producto sin casilla)
    return document.querySelector('[data-cr-casilla]') ? el : null;
  }
  function block(e, el){ e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); showError(el); }
  document.addEventListener('change', function(e){
    if (e.target && e.target.matches && e.target.matches('[data-cr-casilla-input]')){ set(e.target.checked); sync(); }
  }, true);
  ['click','pointerdown','touchstart','keydown'].forEach(function(type){
    document.addEventListener(type, function(e){
      if (ok()) return;
      if (type==='keydown' && e.key!=='Enter' && e.key!==' ') return;
      var el = isCheckout(e.target); if (!el) return;
      if (type==='pointerdown' || type==='touchstart'){ // solo pago rápido (iframes/shadow) necesita esto
        if (el.matches('[name="checkout"], a')) return;
      }
      block(e, el);
    }, {capture:true, passive:false});
  });
  document.addEventListener('submit', function(e){
    if (ok()) return;
    var f = e.target, sub = e.submitter;
    var goesCheckout = (sub && sub.name==='checkout') || /\/checkout/.test(f.getAttribute('action')||'') || f.querySelector('input[name="checkout"][type="hidden"]');
    if (goesCheckout && document.querySelector('[data-cr-casilla]')) block(e, sub || f);
  }, true);
  // Re-render del drawer / AJAX: re-sincroniza la casilla con sessionStorage
  new MutationObserver(function(){ clearTimeout(window.__crT); window.__crT=setTimeout(sync,30); })
    .observe(document.documentElement,{childList:true,subtree:true});
  document.readyState==='loading' ? document.addEventListener('DOMContentLoaded', sync) : sync();
})();
